export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13877.ebb8b6dc.jpg";